import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { VIPPS_BUTTON_SCRIPT_URL } from '@lib/constants';
import { useScript } from '../hooks/useScript';

interface VippsLoginButtonProps {
  returnUrl: string;
  variant?: 'primary' | 'dark' | 'light';
  isStretched?: boolean;
  isBranded?: boolean;
  isRounded?: boolean;
  verb?: 'register' | 'login';
  onLoginStart?: () => void;
}

export const VippsLoginButton = ({
  returnUrl,
  variant = 'primary',
  isRounded = false,
  isStretched = false,
  isBranded = true,
  verb = 'register',
  onLoginStart,
}: VippsLoginButtonProps) => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const [isLoading, setIsLoading] = useState(false);

  useScript(VIPPS_BUTTON_SCRIPT_URL, 'vipps-button');

  if (isAuthenticated) return null;

  return (
    <vipps-mobilepay-button
      type="button"
      brand="vipps"
      variant={variant}
      rounded={isRounded.toString()}
      language="no"
      verb={verb}
      stretched={isStretched.toString()}
      branded={isBranded.toString()}
      loading={isLoading.toString()}
      onClick={() => {
        onLoginStart?.();
        setIsLoading(true);
        loginWithRedirect({
          authorizationParams: { connection: 'VippsLogin' },
          appState: { returnTo: returnUrl },
        });
      }}
    />
  );
};
